export type Bi = { fr: string; en: string }

export const TRUST_HERO_CITY =
  'https://cdn.magicpatterns.com/patterns/generated-images/bdda70cb-8769-4c08-ac45-22321186e1d1.jpg'

export const trustHeroCopy = {
  eyebrow: { fr: 'Confiance et gouvernance', en: 'Trust & governance' },
  headline: {
    line1: { fr: 'Une intelligence', en: 'An intelligence' },
    line2: { fr: 'qui mérite ', en: 'that deserves ' },
    accent: { fr: 'votre confiance.', en: 'your trust.' },
  },
  body: {
    fr: 'BCITI | ATNA relie identité vérifiée, contexte autorisé, sources fiables et gouvernance pour comprendre, recommander et agir avec confiance.',
    en: 'BCITI | ATNA connects verified identity, authorized context, reliable sources and governance to understand, recommend and act with confidence.',
  },
  cta: { fr: 'Demander une démo', en: 'Request a demo' },
}

export type TrustSignalKey = 'sources' | 'rules' | 'data' | 'systems' | 'oversight' | 'audit'

export const trustSignals: { key: TrustSignalKey; label: Bi }[] = [
  { key: 'sources', label: { fr: 'Sources officielles', en: 'Official sources' } },
  { key: 'rules', label: { fr: 'Règles et politiques', en: 'Rules and policies' } },
  { key: 'data', label: { fr: 'Données municipales', en: 'Municipal data' } },
  { key: 'systems', label: { fr: 'Systèmes connectés', en: 'Connected systems' } },
  { key: 'oversight', label: { fr: 'Supervision humaine', en: 'Human oversight' } },
  { key: 'audit', label: { fr: 'Audit et traçabilité', en: 'Audit and traceability' } },
]

/* Illustrative demo UI values only — not measured BCITI | ATNA performance. */
export const trustDashboard = {
  demoNote: 'DEMO / ILLUSTRATIVE DATA ONLY',
  city: 'Brossard',
  title: { fr: 'Vue d’ensemble', en: 'Overview' },
  nav: [
    { fr: 'Accueil', en: 'Home' },
    { fr: 'Mes services', en: 'My services' },
    { fr: 'Requêtes', en: 'Requests' },
    { fr: 'Permis', en: 'Permits' },
    { fr: 'Paiements', en: 'Payments' },
    { fr: 'Communications', en: 'Communications' },
    { fr: 'Documents', en: 'Documents' },
    { fr: 'Analytique', en: 'Analytics' },
  ],
  recommendations: {
    label: { fr: 'Recommandations', en: 'Recommendations' },
    value: { fr: '1 284', en: '1,284' },
    delta: { fr: '+12 %', en: '+12%' },
    period: { fr: 'Ce mois-ci', en: 'This month' },
  },
  confidence: {
    label: { fr: 'Indice de confiance', en: 'Confidence rate' },
    value: { fr: '0,82', en: '0.82' },
    level: { fr: 'Élevé', en: 'High' },
  },
  activity: { fr: 'Activité des services', en: 'Service activity' },
  months: { fr: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin'], en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] },
  sourcesTitle: { fr: 'Sources consultées', en: 'Sources consulted' },
  sources: [
    { label: { fr: 'Règlements municipaux', en: 'Municipal by-laws' }, value: { fr: '42 %', en: '42%' }, color: '#22A06B' },
    { label: { fr: 'Politiques et procédures', en: 'Policies and procedures' }, value: { fr: '28 %', en: '28%' }, color: '#6D5DE8' },
    { label: { fr: 'Données municipales', en: 'Municipal data' }, value: { fr: '18 %', en: '18%' }, color: '#4F7BE8' },
    { label: { fr: 'Systèmes connectés', en: 'Connected systems' }, value: { fr: '12 %', en: '12%' }, color: '#5FBF8F' },
  ],
}

export const trustPhone = {
  city: 'Brossard',
  card: { fr: 'Carte numérique BCITI', en: 'BCITI Digital Card' },
  name: 'Marie Tremblay',
  role: { fr: 'Citoyenne', en: 'Resident' },
  services: { fr: 'Mes services', en: 'My services' },
  tiles: [
    { key: 'requests', label: { fr: 'Requêtes', en: 'Requests' } },
    { key: 'permits', label: { fr: 'Permis', en: 'Permits' } },
    { key: 'payments', label: { fr: 'Paiements', en: 'Payments' } },
    { key: 'collect', label: { fr: 'Collectes', en: 'Waste collection' } },
    { key: 'comms', label: { fr: 'Communications', en: 'Communications' } },
    { key: 'more', label: { fr: 'Plus de services', en: 'More services' } },
  ],
  tabs: [
    { fr: 'Accueil', en: 'Home' },
    { fr: 'Services', en: 'Services' },
    { fr: 'Messages', en: 'Messages' },
    { fr: 'Profil', en: 'Profile' },
  ],
} as const
